import _extends from "@babel/runtime/helpers/esm/extends";
import { Bridge } from "../_";
import { SuperDashboardCard } from "../SuperDashboard";
import { ApplicationOne } from '@icon-park/react';
import { Col, Row, Typography } from 'antd';
import React from 'react';
import { useStyles } from "./RecentVisit.style";
export var RecentVisit = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    title: "\u8FD1\u671F\u8BBF\u95EE",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    gutter: 8,
    wrap: true
  }, properties.datum.map(function (data) {
    return /*#__PURE__*/React.createElement(Col, {
      span: 12,
      key: data.key
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return Bridge.history.push(data.value);
      },
      className: styles.item
    }, /*#__PURE__*/React.createElement(ApplicationOne, {
      theme: "outline"
    }), /*#__PURE__*/React.createElement(Typography.Text, {
      ellipsis: true
    }, data.key)));
  }))), properties.children);
});
RecentVisit.isProCard = true;